import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";

const POS = ["1st", "2nd", "3rd"];

export const ResultEntry = ({ meetingId, race, onSaved }) => {
  const api = useApi();
  const [p, setP] = useState(["", "", ""]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setP([0, 1, 2].map((i) => String(race.result?.placings?.[i]?.number || ""))); }, [race.number, race.result]);
  const runners = race.runners.filter((r) => !r.scratched);

  const save = async () => {
    const gap = p.findIndex((x) => !x);
    if (gap !== -1 && p.slice(gap).some(Boolean)) { toast.error(`Fill in ${["1st", "2nd", "3rd"][gap]} before later places`); return; }
    setBusy(true);
    try {
      await api("put", `/admin/meetings/${meetingId}/races/${race.number}/result`, { placings: p.filter(Boolean).map(Number) });
      toast.success("Result saved"); onSaved();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const clear = async () => {
    setBusy(true);
    try { await api("delete", `/admin/meetings/${meetingId}/races/${race.number}/result`); toast.success("Result cleared"); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <section className="rounded-2xl bg-[#131C31] border border-white/10 p-5" data-testid="result-entry">
      <h3 className="font-display font-bold mb-1 flex items-center gap-2"><Flag className="w-4 h-4 text-emerald-400" />Enter official result</h3>
      <p className="text-xs text-slate-500 mb-3">Use the official placings once the race is run. Only published tips count towards the strike rate.</p>
      <div className="flex flex-wrap gap-2 items-center">
        {POS.map((label, i) => (
          <label key={label} className="flex items-center gap-1.5 text-xs text-slate-400">{label}
            <select data-testid={`result-pos-${i + 1}`} value={p[i]} onChange={(e) => setP(p.map((x, j) => (j === i ? e.target.value : x)))}
              className="bg-[#0B101D] border border-white/10 rounded px-2 py-1.5 text-xs max-w-[11rem]">
              <option value="">{i === 0 ? "Select winner" : "—"}</option>
              {runners.map((r) => <option key={r.number} value={r.number}>{r.number}. {r.horse}</option>)}
            </select>
          </label>
        ))}
        <button data-testid="result-save-button" onClick={save} disabled={busy || !p[0]} className="px-4 py-1.5 rounded-full bg-emerald-600 hover:bg-emerald-500 text-xs font-semibold disabled:opacity-40">Save result</button>
        {race.result && <button data-testid="result-clear-button" onClick={clear} disabled={busy} className="px-3 py-1.5 rounded-full text-xs text-slate-400 hover:text-white">Clear</button>}
      </div>
    </section>
  );
};
